<template>
  <div class="selector-grid__wrapper">
    <dress-item v-for="(item,i) in items" :key="item.id" :item="item" :i="i"></dress-item>
    <!--<div class="selector-grid__item selector-grid__item&#45;&#45;dress"-->
         <!--:class="selectedDress && selectedDress === item  ? 'selected' : ''"-->
         <!--v-for="(item,i) in items" :key="item.id"-->
         <!--@click="setDress(item,i)">-->


      <!--<div v-if="!item.loaded" class="loading-bar text-red absolute">loading</div>-->

      <!--<div class="selector-grid__image-container selector-grid__image-container&#45;&#45;dress" :style="{backgroundImage: `url(${item.image})`}" alt=""></div>-->
      <!--<h4 class="selector-grid__title selector-grid__title&#45;&#45;dress">{{ '0'+(i+1) }}</h4>-->
    <!--</div>-->
  </div>
</template>

<script>
  // import { mapActions, mapGetters } from 'vuex';
  import DressItem from './DressItem'

  export default {
    name: "DressGrid",
    components: {
      DressItem
    },
    props: {
      items: {
        type: Array,
        default: () => {
          return [];
        }
      }
    },
    // computed: {
    //   ...mapGetters('clothes',[
    //     'selectedClothes',
    //     'selectedDress',
    //     'selectedDressInClothes',
    //     'defaultTopDress',
    //     'defaultBottomDress'
    //   ]),
    // },
    // methods: {
    //   ...mapActions('clothes',[
    //     'wearDress',
    //     'unwearDress',
    //   ]),
    //   ...mapActions([
    //     'render'
    //   ]),
    //   setDress(item,i) {
    //
    //     // console.log(this.poser);
    //     // console.log(item);
    //     this.wearDress(item).then( () => {
    //       // console.log('in component render');
    //       this.render();
    //       this.$refs.slider && this.$refs.slider.goToSlide(i);
    //     });
    //
    //   }
    // },
  }
</script>

<style scoped>

</style>